/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1546
 */

import { f } from "./1546__part-1"
export { f as a }
export default f
